var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "p-20" },
    [
      _c("h1", { staticClass: "mt-0" }, [
        _vm._v(_vm._s(_vm.$t("CreditNoteDetail.title")))
      ]),
      _vm._v(" "),
      _c(
        "el-row",
        { attrs: { gutter: 5 } },
        [
          _c(
            "el-col",
            { attrs: { span: 17 } },
            [
              _c(
                "el-card",
                { staticClass: "mb-5" },
                [
                  _vm.creditNote
                    ? _c("document-detail", {
                        attrs: {
                          document: _vm.creditNote,
                          "document-type": "credit_note"
                        }
                      })
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _vm.creditNote && _vm.creditNote.custom_fields
                ? _c(
                    "el-card",
                    { staticClass: "mb-5" },
                    [
                      _c("h4", { staticClass: "mb-20" }, [
                        _vm._v(_vm._s(_vm.$t("shared.custom_fields")))
                      ]),
                      _vm._v(" "),
                      _vm.userInterfaceDetails &&
                      _vm.userInterfaceDetails.custom_field_definitions
                        ? _c("custom-fields-list", {
                            attrs: {
                              "custom-field-definitions":
                                _vm.userInterfaceDetails
                                  .custom_field_definitions,
                              "custom-fields": _vm.creditNote.custom_fields
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          staticClass: "mb-10",
                          attrs: { size: "mini" },
                          on: {
                            click: function($event) {
                              _vm.showCustomFields = !_vm.showCustomFields
                            }
                          }
                        },
                        [
                          _vm.showCustomFields
                            ? _c("span", [
                                _vm._v(
                                  "\n\t\t\t\t\t\t" +
                                    _vm._s(
                                      _vm.$t("shared.hide_custom_fields")
                                    ) +
                                    "\n\t\t\t\t\t"
                                )
                              ])
                            : _c("span", [
                                _vm._v(
                                  "\n\t\t\t\t\t\t" +
                                    _vm._s(
                                      _vm.$t("shared.show_custom_fields")
                                    ) +
                                    "\n\t\t\t\t\t"
                                )
                              ])
                        ]
                      ),
                      _vm._v(" "),
                      _vm.showCustomFields
                        ? _c("json-editor", {
                            attrs: { value: _vm.creditNote.custom_fields }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-card",
                { staticClass: "mb-5" },
                [
                  _vm._l(_vm.files, function(file) {
                    return [
                      _c(
                        "el-button",
                        {
                          key: `${file.name}-btn`,
                          attrs: { type: "primary", size: "mini" },
                          on: {
                            click: function($event) {
                              return _vm.onDownload(file)
                            }
                          }
                        },
                        [
                          _vm._v(
                            " Download " +
                              _vm._s(_vm.$tc("creditnote", 1).toLowerCase()) +
                              " "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _vm.isUriAttachment(file) && !file.uri.startsWith("s3")
                        ? _c("pdf", {
                            key: file.name,
                            attrs: { src: file.uri }
                          })
                        : _vm._e()
                    ]
                  })
                ],
                2
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("el-col", { attrs: { span: 7 } })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }